/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListUserSessionIssuerCimdClientsResult,
  ListUserSessionIssuerCimdClientsResult$inboundSchema,
} from "../components/listusersessionissuercimdclientsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListOrganizationUserSessionIssuerCimdClientsSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListOrganizationUserSessionIssuerCimdClientsRequest = {
  /**
   * The organization-owned user_session_issuer whose custom CIMD clients are listed.
   */
  userSessionIssuerId: string;
  /**
   * Pagination cursor: id of the last item from the previous page.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

export type ListOrganizationUserSessionIssuerCimdClientsResponse = {
  result: ListUserSessionIssuerCimdClientsResult;
};

/** @internal */
export type ListOrganizationUserSessionIssuerCimdClientsSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationUserSessionIssuerCimdClientsSecurity$outboundSchema:
  z.ZodMiniType<
    ListOrganizationUserSessionIssuerCimdClientsSecurity$Outbound,
    ListOrganizationUserSessionIssuerCimdClientsSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listOrganizationUserSessionIssuerCimdClientsSecurityToJSON(
  listOrganizationUserSessionIssuerCimdClientsSecurity:
    ListOrganizationUserSessionIssuerCimdClientsSecurity,
): string {
  return JSON.stringify(
    ListOrganizationUserSessionIssuerCimdClientsSecurity$outboundSchema.parse(
      listOrganizationUserSessionIssuerCimdClientsSecurity,
    ),
  );
}

/** @internal */
export type ListOrganizationUserSessionIssuerCimdClientsRequest$Outbound = {
  user_session_issuer_id: string;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListOrganizationUserSessionIssuerCimdClientsRequest$outboundSchema:
  z.ZodMiniType<
    ListOrganizationUserSessionIssuerCimdClientsRequest$Outbound,
    ListOrganizationUserSessionIssuerCimdClientsRequest
  > = z.pipe(
    z.object({
      userSessionIssuerId: z.string(),
      cursor: z.optional(z.string()),
      limit: z.optional(z.int()),
      gramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        userSessionIssuerId: "user_session_issuer_id",
        gramSession: "Gram-Session",
      });
    }),
  );

export function listOrganizationUserSessionIssuerCimdClientsRequestToJSON(
  listOrganizationUserSessionIssuerCimdClientsRequest:
    ListOrganizationUserSessionIssuerCimdClientsRequest,
): string {
  return JSON.stringify(
    ListOrganizationUserSessionIssuerCimdClientsRequest$outboundSchema.parse(
      listOrganizationUserSessionIssuerCimdClientsRequest,
    ),
  );
}

/** @internal */
export const ListOrganizationUserSessionIssuerCimdClientsResponse$inboundSchema:
  z.ZodMiniType<ListOrganizationUserSessionIssuerCimdClientsResponse, unknown> =
    z.pipe(
      z.object({
        Result: ListUserSessionIssuerCimdClientsResult$inboundSchema,
      }),
      z.transform((v) => {
        return remap$(v, {
          "Result": "result",
        });
      }),
    );

export function listOrganizationUserSessionIssuerCimdClientsResponseFromJSON(
  jsonString: string,
): SafeParseResult<
  ListOrganizationUserSessionIssuerCimdClientsResponse,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      ListOrganizationUserSessionIssuerCimdClientsResponse$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'ListOrganizationUserSessionIssuerCimdClientsResponse' from JSON`,
  );
}
